import { Service } from "./restService";

class CustomerService extends Service {

    addCustomer = (customerData) => {
        const url = 'customer';
        return this.POST(url, JSON.stringify(customerData))
            .then(response => response);
    }

    updateCustomer = (customerData) => {
        const url = 'customer';
        return this.POST(url, JSON.stringify(customerData))
            .then(response => response);
    }

    getCustomerById = (customerId) => {
        const url = 'customer/' + customerId;
        return this.GET(url)
            .then(response => response);
    };

    getCustomerAttributesById = (customerId) => {
        const url = 'customer/' + customerId + '/values/attributes/SERVER_SCOPE';
        return this.GET(url)
            .then(response => response);
    };

    getCustomers = () => {
        const url = 'customers?pageSize=100&page=0&textSearch=';
        return this.GET(url)
            .then(response => response);
    }

    addEntityToCustomerRelation = (entityViewId, customerId) => {
        const url = 'relation';
        let body = {
            from: { entityType: "CUSTOMER", id: customerId },
            to: { entityType: "ENTITY_VIEW", id: entityViewId },
            type: 'Contains',
            typeGroup: "COMMON",
            additionalInfo: '',
        }
        return this.POST(url, JSON.stringify(body))
            .then(response => response);
    }

    assignEntityToCustomer = (entityViewId, customerId) => {
        const url = `customer/${customerId}/entityView/${entityViewId}`;
        return this.POST(url)
            .then(response => response);
    }

    getCustomerEntities = (customerId) => {
        const subPath = `relations`;
        const query = {
            fromId: customerId,
            relationType: 'Contains',
            fromType: 'CUSTOMER',
        }

        return this.QUERY(subPath, query)
            .then((response) => {
                let data = [];
                for (let i = 0; i < response.length; i++) {
                    if (response[i].to.entityType === 'ENTITY_VIEW') {
                        data.push(response[i]);
                    }
                }
                return data;
            });
    }
    getCustomerFieldEntities = (customerId, entityType) => {

        const subPath = `customer/${customerId}/entityViews`;
        const query = {
            type: entityType,
            pageSize: 100,
            page: 0
        }

        return this.QUERY(subPath, query)
            .then(response => response.data);
    }
}

export default CustomerService;
export {
    CustomerService
}